import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/sections/Hero';
import { SocialProof } from './components/sections/SocialProof';
import { Testimonials } from './components/sections/Testimonials';
import { PainPoints } from './components/sections/PainPoints';
import { SystemComparison } from './components/sections/SystemComparison';
import { ProductShowcase } from './components/sections/ProductShowcase';
import { Bonuses } from './components/sections/Bonuses';
import { Pricing } from './components/sections/Pricing';
import { PlugPlayComparison } from './components/sections/PlugPlayComparison';
import { Guarantee } from './components/sections/Guarantee';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  const testimonials1 = ['En menos de una semana ya estaba vendiendo.', 'Pasé de no saber nada a generar ingresos.', 'Es simple, directo y funciona.'];
  const testimonials2 = ['Con esto empecé a vender más rápido', 'No tuve que pensar nada', 'Es el atajo que necesitaba'];
  return <div className="min-h-screen bg-dark-900 text-white font-sans selection:bg-gold-500 selection:text-black" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <SocialProof data-id="element-3" />
      <Testimonials quotes={testimonials1} data-id="element-4" />
      <PainPoints data-id="element-5" />
      <SystemComparison data-id="element-6" />
      <ProductShowcase data-id="element-7" />
      <Bonuses data-id="element-8" />
      <Pricing data-id="element-9" />
      <PlugPlayComparison data-id="element-10" />
      <Testimonials title="💬 MÁS PERSONAS QUE YA LO USAN" quotes={testimonials2} data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}